import React, { useContext, useCallback } from 'react';
import { InputLabel, FormControl, Input, Select, MenuItem, Checkbox, ListItemText, Chip } from '@material-ui/core';

import { ConfigContext } from '../config';
import { SHAPE_KEYS } from '../shapes';

export const ShapesField = ({ id, label, ...props }) => {
  const { useConfig, setConfig } = useContext(ConfigContext);
  const value = useConfig(id);

  const handleChange = useCallback(
    (event) => {
      setConfig(id, event.target.value);
    },
    [setConfig, id],
  );

  return (
    <FormControl fullWidth>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        multiple
        value={value}
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) => (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {selected.map((value) => (
              <Chip key={value} label={value} size="small" style={{ margin: '0.1rem 0.05rem' }} />
            ))}
          </div>
        )}>
        {SHAPE_KEYS.map((shape) => (
          <MenuItem key={shape} value={shape} dense>
            <Checkbox checked={value.indexOf(shape) > -1} size="small" style={{ paddingTop: 0, paddingBottom: 0 }} />
            <ListItemText primary={shape} size="small" />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ShapesField;
